import { Component } from 'react'

import EstimationStore from '../../../libs/EstimationStore'
import EstimationActions from '../../../libs/EstimationActions'

class Description extends Component {
  getHeisei (seireki) {
    return seireki - 1988
  }
  getYM (ym) {
    return {
      y: Math.floor(ym / 100),
      m: ym % 100
    }
  }
  getSetting (settingName) {
    const estimation = EstimationActions.getCurrentEstimation()
    const estimationYearMonthId = estimation.estimationYearMonthId
    const settingList = EstimationStore.getDataFromStorage(settingName)
    return settingList.filter(setting => ((estimationYearMonthId >= setting.startMonth && estimationYearMonthId <= setting.endMonth)))[0]
  }
}
export default Description



// WEBPACK FOOTER //
// ./src/company_user/print/LaborUnitPriceTab/abstract/Description.js